// Resolución No. 07 - 11 de mayo de 2026 (AIG, Panamá)
// Controles mínimos requeridos de Protección en Ciberseguridad para Sistemas Informáticos
// de las Entidades Públicas.
// Fuente: Gaceta Oficial Digital No. 30524 B, jueves 14 de mayo de 2026.

export const COMPLIANCE_STATUSES = [
  { id: 'cumple', label: 'Cumple', color: 'bg-green-500/20 text-green-400 border-green-500/30' },
  { id: 'parcial', label: 'Parcial', color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' },
  { id: 'no_cumple', label: 'No Cumple', color: 'bg-red-500/20 text-red-400 border-red-500/30' },
  { id: 'no_aplica', label: 'No Aplica', color: 'bg-gray-500/20 text-gray-400 border-gray-500/30' },
];

export const IT_CYBERSECURITY_CONTROLS = [
  {
    id: 'inventario_internet',
    numero: 1,
    titulo: 'Inventario de activos expuestos a Internet',
    descripcion: 'Mantener un inventario actualizado de los activos tecnológicos expuestos a Internet, incluyendo su finalidad, ubicación lógica y responsable designado.',
  },
  {
    id: 'actualizacion_parchado',
    numero: 2,
    titulo: 'Actualización y parchado de activos tecnológicos',
    descripcion: 'Mantener actualizados y con parches de seguridad todos los activos tecnológicos: servidores, aplicaciones, servicios y dispositivos de red perimetral. Prioridad para los expuestos a Internet.',
  },
  {
    id: 'mfa_accesos_remotos',
    numero: 3,
    titulo: 'Autenticación multifactor (MFA) para accesos remotos',
    descripcion: 'Implementar MFA como mínimo para: (a) acceso remoto a la red institucional mediante VPN; (b) correo electrónico institucional fuera de la red interna; (c) plataformas SaaS incluyendo redes sociales.',
  },
  {
    id: 'sistemas_operativos_vigentes',
    numero: 4,
    titulo: 'Sistemas operativos vigentes y con soporte',
    descripcion: 'Contar con sistemas operativos vigentes y con soporte del fabricante en la red interna y externa. Equipos sin soporte deben aislarse y contar con medidas de mitigación.',
  },
  {
    id: 'proteccion_malware',
    numero: 5,
    titulo: 'Protección contra malware',
    descripcion: 'Soluciones anti-malware instaladas y activas en estaciones de trabajo y servidores, con firmas o mecanismos de detección actualizados.',
  },
  {
    id: 'dmz_waf',
    numero: 6,
    titulo: 'Segmentación perimetral mediante DMZ',
    descripcion: 'Los sistemas y servicios expuestos a Internet deben ubicarse en una zona desmilitarizada (DMZ) o segmento equivalente, protegidos por un Web Application Firewall (WAF). No deben alojarse en la red interna sin segmentación.',
  },
  {
    id: 'restriccion_acceso_admin',
    numero: 7,
    titulo: 'Restricción de accesos administrativos desde Internet',
    descripcion: 'Restringir accesos administrativos (SSH, RDP, SMB, bases de datos, interfaces de red, etc.) desde Internet. Evitar disponibilidad directa desde redes públicas con controles adicionales de acceso.',
  },
  {
    id: 'pentest_externo',
    numero: 8,
    titulo: 'Prueba de penetración externa anual',
    descripcion: 'Realizar al menos una (1) prueba de penetración externa anual sobre los activos expuestos a Internet, documentando hallazgos y acciones de remediación.',
  },
  {
    id: 'filtrado_web',
    numero: 9,
    titulo: 'Protección mediante filtrado de navegación web',
    descripcion: 'Mecanismos de filtrado de navegación web para prevenir acceso a sitios maliciosos, fraudulentos o de alto riesgo (malware, phishing, etc.), operativos y actualizados.',
  },
  {
    id: 'proteccion_correo',
    numero: 10,
    titulo: 'Protección del correo electrónico institucional',
    descripcion: 'Controles de seguridad para correo institucional: detección y bloqueo de correos maliciosos, enlaces fraudulentos, adjuntos peligrosos o suplantación de identidad. Activos y actualizados.',
  },
];

export const REGULATION_REFERENCE = {
  norma: 'Resolución No. 07 de 11 de mayo de 2026',
  emisor: 'Autoridad Nacional para la Innovación Gubernamental (AIG)',
  publicacion: 'Gaceta Oficial Digital No. 30524 B - 14 de mayo de 2026',
  fundamento: 'Ley 65 de 30 de octubre de 2009',
  plazo_informe_autogestion_dias: 30,
  plazo_plan_accion_dias: 45,
};

export function emptyChecklist() {
  return IT_CYBERSECURITY_CONTROLS.map(c => ({
    control_id: c.id,
    estado: '',
    evidencia: '',
    plan_accion: '',
    fecha_objetivo: '',
    notas: '',
  }));
}

export function mergeChecklistWithControls(stored) {
  const base = emptyChecklist();
  if (!Array.isArray(stored)) return base;
  const byId = new Map(stored.map(item => [item.control_id, item]));
  return base.map(item => ({ ...item, ...(byId.get(item.control_id) || {}) }));
}

export function computeComplianceSummary(checklist = []) {
  const counts = { cumple: 0, parcial: 0, no_cumple: 0, no_aplica: 0, sin_evaluar: 0 };
  for (const item of checklist) {
    if (!item.estado) counts.sin_evaluar += 1;
    else counts[item.estado] = (counts[item.estado] || 0) + 1;
  }
  const evaluated = checklist.length - counts.sin_evaluar - counts.no_aplica;
  const compliant = counts.cumple + counts.parcial * 0.5;
  const percent = evaluated > 0 ? Math.round((compliant / evaluated) * 100) : 0;
  return { counts, evaluated, percent };
}
